exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resumen_container {\n  padding: 14px 0px 0px 35px;\n  overflow: hidden;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  background-color: #edecec;\n  height: 120% !important;\n}\n\n.resumen_contadores {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.resumen_actividades {\n  margin-top: 12px;\n  height: 64%;\n  width: 95%;\n}", ""]);

// exports
